import { Box, chakra, Flex, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

const ChakraButton = chakra("button");

export interface ChoiceCardProps {
  selected?: boolean;
  onClick: () => void;
  children: ReactNode;
}

export const ChoiceCard = ({ selected, onClick, children }: ChoiceCardProps) => (
  <ChakraButton
    type="button"
    w="100%"
    display="flex"
    alignItems="center"
    gap="14px"
    px="18px"
    py="16px"
    borderRadius="14px"
    borderWidth="1.5px"
    borderColor={selected ? "border.brand" : "border.default"}
    bg={selected ? "bg.brandSoft" : "bg.canvas"}
    color="fg.default"
    cursor="pointer"
    textAlign="left"
    transition="all 120ms"
    boxShadow={selected ? "0 0 0 4px {colors.bg.brandTint}" : "none"}
    onClick={onClick}
  >
    <Box flex="1">
      <Text
        fontSize="15px"
        fontWeight="semibold"
        color={selected ? "fg.onTint" : "fg.default"}
        letterSpacing="-0.005em"
        m="0"
      >
        {children}
      </Text>
    </Box>
    <Flex
      align="center"
      justify="center"
      w="22px"
      h="22px"
      borderRadius="full"
      borderWidth="1.5px"
      borderColor={selected ? "border.brand" : "border.default"}
      bg={selected ? "bg.brand" : "transparent"}
      color="fg.onBrand"
      fontSize="11px"
    >
      {selected && "✓"}
    </Flex>
  </ChakraButton>
);
